<template>
    <div class="sky_loader" v-if="this.$root.fullscreenLoading">
        <div class="__visibility_block"></div>
        <div class="__loader_wrap">
            <div class="__loader_image"><span></span></div>
            <div class="__loader_content">Уншиж байна ...</div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    isLoader: Boolean
  }
}
</script>
